<div class="header-row">
  <div class="header">Ukupna Statistika</div>
  <div class="controls-container">

    <button mat-icon-button 
            class="refresh-btn" 
            (click)="updateGrafana()" 
            matTooltip="Osveži podatke"
            aria-label="Refresh data">
      <mat-icon>refresh</mat-icon>
    </button>

    <button mat-icon-button 
            class="refresh-btn" 
            type="button"
            matTooltip="Obriši sve filtere"
            (click)="clearAllFilters()"
            [disabled]="!dateFrom && !dateTo && !selectedUstanova && !selectedLaboratorija">
      <mat-icon>clear</mat-icon> 
    </button>

    <app-advanced-interval-picker
      [initialFrom]="dateFrom"
      [initialTo]="dateTo"
      [quickRanges]="myDashboardRanges"
      (intervalChanged)="onIntervalUpdated($event)">
    </app-advanced-interval-picker>


    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Ustanova</mat-label>

      <input type="text"
             matInput
             placeholder="Izaberite ustanovu"
             [disabled]="!dateTo"
             [(ngModel)]="searchUstanovaText"
             (input)="filtrirajUstanove($event)"
             [matAutocomplete]="auto"
             #autoTrigger="matAutocompleteTrigger" 
             (focus)="otvoriUstanove()">
            
      <button (click)="$event.stopPropagation(); otvoriUstanove(); autoTrigger.openPanel()" 
              matSuffix 
              mat-icon-button 
              [disabled]="!dateTo" 
              style="border: none; background: transparent; cursor: pointer;">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-autocomplete #auto="matAutocomplete" 
                        [displayWith]="displayFn"
                        (optionSelected)="onUstanovaSelected($event.option.value)">
        <mat-option *ngFor="let u of ustanoveFiltered" [value]="u">
          {{ u.text }}
        </mat-option>
        
        <mat-option *ngIf="ustanoveFiltered.length === 0" disabled>
          Nema pronađenih ustanova
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Laboratorija</mat-label>

      <input type="text"
             matInput
             placeholder="Izaberite laboratoriju"
             [disabled]="!selectedUstanova" 
             [(ngModel)]="searchLaboratorijaText"
             (input)="filtrirajLaboratorije($event)"
             [matAutocomplete]="autoLab"
             #labTrigger="matAutocompleteTrigger"
             (focus)="otvoriLaboratorije()">
            
      <button matSuffix 
              mat-icon-button 
              type="button"
              [disabled]="!selectedUstanova"
              (click)="$event.stopPropagation(); otvoriLaboratorije(); labTrigger.openPanel()"
              style="border: none; background: transparent; cursor: pointer;">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-autocomplete #autoLab="matAutocomplete" 
                        [displayWith]="displayFn"
                        (optionSelected)="onLaboratorijaSelected($event.option.value)">
        <mat-option *ngFor="let l of laboratorijeFiltered" [value]="l">
          {{ l.text }}
        </mat-option>
        
        <mat-option *ngIf="laboratorijeFiltered.length === 0" disabled>
          Nema pronađenih laboratorija
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</div>

<div class="dashboard-viewport">
  <div *ngIf="grafanaHtml" 
       class="iframe-wrapper" 
       [innerHTML]="grafanaHtml">
  </div>
</div>